module.exports = __webpack_public_path__ + "static/media/next-step-button.25ee9365.svg";